import { css } from '@/styled-system/css';

// Mobile header styles
export const headerNavMobileStyles = css.raw({
  height: '42px',
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  backgroundColor: 'white',
  lg: {
    display: 'none',
  },
});

// Desktop header wrapper
export const headerNavDesktopStyles = css.raw({
  display: 'none',
  lg: {
    display: 'block',
    '& header': {
      width: '100%',
      backgroundColor: 'white',
    },
  },
});

// Desktop navigation styles
export const headerNavStyles = css.raw({
  width: '100%',
  height: '56px',
  paddingInline: 'default',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
});

// Logo wrapper
export const logoWrapperStyles = css.raw({
  display: 'inline-block',
  marginRight: 'default',
  verticalAlign: 'text-bottom',
  width: '110px',
  position: 'relative',
  top: '-4px',
});

// Mobile logo
export const mobileLogoStyles = css.raw({
  height: '24px',
  marginLeft: 'tight',
});

// Nav list (for List.Root)
export const navListStyles = css.raw({
  display: 'inline-flex',
  alignItems: 'center',
  height: '100%',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

// Nav list item (for List.Item)
export const navListItemStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  margin: 0,
  padding: 0,
});

// Nav menu item (link)
export const navMenuItemStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  paddingInline: 'tight',
  margin: 0,
  textDecoration: 'none',
  letterSpacing: '0.5px',
  '&.active a': {
    color: 'text.neutral',
  },
});

export const navMenuLinkStyles = css.raw({
  textDecoration: 'none',
  color: 'text.subtle',
  '&:visited': {
    color: 'text.subtle',
  },
  '&:hover': {
    color: 'text.neutral',
  },
});

// Login status container
export const loginStatusStyles = css.raw({
  position: 'absolute',
  top: 0,
  right: 0,
  minWidth: '150px',
  textAlign: 'right',
  height: '40px',
  lgDown: {
    lineHeight: '40px',
  },
  lg: {
    minWidth: '172px',
    height: '56px',
  },
  '& a': {
    textDecoration: 'none',
    letterSpacing: '0.5px',
  },
});

// Manage properties link (desktop only)
export const managePropertiesStyles = css.raw({
  display: 'none',
  xl: {
    borderRight: '1px solid',
    borderColor: 'gray.400',
    display: 'inline-block',
    paddingRight: 'tight',
    marginRight: 'tight',
  },
});

// Mobile right section
export const navMobileRightStyles = css.raw({
  height: '100%',
  display: 'inline-block',
  width: '70px',
});

// Login status link/button
export const loginStatusLinkStyles = css.raw({
  height: '100%',
  display: 'inline-block',
  paddingRight: '16px',
  lg: {
    lineHeight: '56px',
  },
});

// Profile icon
export const profileIconStyles = css.raw({
  width: '16px',
  height: '16px',
  marginRight: '6px',
  top: '-1px',
  position: 'relative',
  verticalAlign: 'middle',
});
